import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  aboutUs: {},
  aboutUsLoading: false,
  faq: [],
  faqLoading: false,
  contactUs: {},
  contactUsLoading: false,
  submitContactFormLoading: false,
  submitContactForm: "",
  recruitByType: {},
  recruitByTypeLoading: false,
  gettingStartedByType: [],
  gettingStartedByTypeLoading: false,
  coachFeaturesByType: [],
  coachFeaturesByTypeLoading: false,
  featuresByType: [],
  featuresByTypeLoading: false,
  pricing: {},
  pricingLoading: false,
  athletepricing: [],
  athletePricingLoading: false,
  premiumclubHeadCoachPricing: [],
  premiumclubHeadCoachLoadingPricing: false,
  pricingDetail: [],
  pricingDetailLoading: false,
  pricingDetaiPictures: {},
  pricingDetaiPicturesLoading: false,
  privacyPolicy: {},
  privacyPolicyLoading: false,
  termsAndConditions: {},
  termsAndConditionsLoading: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
